module.exports = {
  ENV: process.env.ENV,
  GOOGLE_MAPS_KEY: "AIzaSyCTNvdceUfSk8WYe1YtmCsSZBChre7z9N4",
  GOOGLE_MAPS_ID: "22d913cfa0f040323e8277e6",
  SITE: "https://fortepan.eu",
  SITE_DEV: "https://fortepan.eu",
  BACKEND: "https://backend.fortepan.eu",
  BACKEND_DEV: "https://back.fortepan.eu",
  PHOTO_SOURCE: "https://djhqbtjenf12x.cloudfront.net",
  PHOTO_BUCKET: "fortepanproject",
  THUMBNAILS_QUERY_LIMIT: 40,
  BREAKPOINT_PHONE_XS: 360,
  BREAKPOINT_PHONE_SM: 480,
  BREAKPOINT_PHONE: 640,
  BREAKPOINT_TABLET: 768,
  BREAKPOINT_DESKTOP: 1024,
  BREAKPOINT_DESKTOP_LG: 1220,
  CAROUSEL_SLIDESHOW_DELAY: 4000,
  DEFAULT_THEME: "light",
  LOCALES: [
    { code: "en", text: "English" },
    { code: "hu", text: "Magyar" },
    { code: "it", text: "Italian" },
    { code: "pl", text: "Polska" },
    { code: "fr", text: "Français" },
  ],
  // LOCALES: {
  //   en: "English",
  //   hu: "Magyar",
  //   it: "Italian",
  //   pl: "Polska",
  //   fr: "Français",
  // },
  AGE_RESTRICTION_TAG: "18+",
}
